import React from 'react';
import { Smartphone, Globe, CheckCircle2, ExternalLink } from 'lucide-react';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.sharmaq.shoficina_mobile&hl=pt_BR';
const OS_WEB_URL = 'https://shoficina.com.br/site/os-na-web.php';

export const AppMobileSection = () => (
  <article className="mb-16" aria-labelledby="app-mobile-title" data-testid="shoficina-app-mobile">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
      {/* App Mobile */}
      <div className="relative bg-gradient-to-br from-slate-800/80 to-slate-900 border border-cyan-500/20 rounded-2xl p-8 overflow-hidden flex flex-col md:flex-row items-center gap-6">
        <div className="absolute -top-16 -right-16 w-48 h-48 bg-cyan-500/10 rounded-full blur-3xl pointer-events-none" />
        <img
          src="./img/shoficina/app-mobile.webp"
          alt="Aplicativo de ordem de serviço para oficina mecânica SHOficina Mobile"
          className="w-40 md:w-48 h-auto drop-shadow-2xl shrink-0"
          loading="lazy"
        />
        <div className="text-center md:text-left">
          <span className="inline-flex items-center gap-1.5 bg-cyan-500/15 text-cyan-400 text-xs font-semibold px-3 py-1 rounded-full mb-3">
            <Smartphone className="w-3.5 h-3.5" /> App Mobile
          </span>
          <h3 id="app-mobile-title" className="text-2xl font-bold text-white mb-2">
            Sua oficina na <span className="text-cyan-400">palma da mão</span>
          </h3>
          <p className="text-slate-400 text-sm mb-4">
            Gerencie sua oficina de onde estiver. Consulte ordens de serviço, clientes e estoque direto pelo celular, integrado ao SHOficina Desktop.
          </p>
          <ul className="space-y-1.5 mb-5 text-left inline-block">
            {['Consulta de O.S. em tempo real', 'Acesso a clientes e veículos', 'Integração total com o desktop'].map(f => (
              <li key={f} className="flex items-center gap-2 text-sm text-slate-300">
                <CheckCircle2 className="w-4 h-4 text-cyan-400 shrink-0" />{f}
              </li>
            ))}
          </ul>
          <div>
            <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-cyan-600 to-blue-600 hover:from-cyan-500 hover:to-blue-500 text-white font-bold px-6 py-3 rounded-xl text-sm shadow-lg shadow-cyan-500/20 transition-all hover:-translate-y-0.5"
              data-testid="app-mobile-download-btn" aria-label="Baixar app SHOficina Mobile na Google Play">
              <Smartphone className="w-4 h-4" /> Baixar na Google Play <ExternalLink className="w-3.5 h-3.5" />
            </a>
          </div>
        </div>
      </div>

      {/* OS Web */}
      <div className="relative bg-gradient-to-br from-slate-800/80 to-slate-900 border border-emerald-500/20 rounded-2xl p-8 overflow-hidden flex flex-col justify-center">
        <div className="absolute -bottom-16 -left-16 w-48 h-48 bg-emerald-500/10 rounded-full blur-3xl pointer-events-none" />
        <span className="inline-flex items-center gap-1.5 bg-emerald-500/15 text-emerald-400 text-xs font-semibold px-3 py-1 rounded-full mb-3 self-start">
          <Globe className="w-3.5 h-3.5" /> OS Web
        </span>
        <h3 className="text-2xl font-bold text-white mb-2">
          Seu cliente acompanha a O.S. <span className="text-emerald-400">online</span>
        </h3>
        <p className="text-slate-400 text-sm mb-4">
          Permita que seus clientes consultem o status do serviço pela internet, sem precisar ligar para a oficina. Mais transparência, menos interrupções no seu dia.
        </p>
        <ul className="space-y-1.5 mb-5">
          {['Consulta de status por link exclusivo', 'Reduz ligações de "já ficou pronto?"', 'Profissionalismo que fideliza clientes'].map(f => (
            <li key={f} className="flex items-center gap-2 text-sm text-slate-300">
              <CheckCircle2 className="w-4 h-4 text-emerald-400 shrink-0" />{f}
            </li>
          ))}
        </ul>
        <div>
          <a href={OS_WEB_URL} target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-2 border-2 border-emerald-500/40 hover:border-emerald-400 hover:bg-emerald-500/10 text-emerald-400 font-bold px-6 py-3 rounded-xl text-sm transition-all"
            data-testid="os-web-btn" aria-label="Conhecer a consulta de OS online">
            <Globe className="w-4 h-4" /> Conhecer OS Web <ExternalLink className="w-3.5 h-3.5" />
          </a>
        </div>
      </div>
    </div>
  </article>
);

export default AppMobileSection;
